<template>
  <div class="chart-footer">
    <template v-if="isLoading">
      <SkeletonLoader class="chart-footer__loader">
        <div class="chart-footer__loader__item" />
        <div class="chart-footer__loader__item" />
      </SkeletonLoader>
    </template>
    <template v-else>
      <BaseText size="xs" :color="NebraskaColors.elementSecondary">{{
        computedLeftText
      }}</BaseText>
      <BaseText size="xs" :color="NebraskaColors.elementSecondary">{{
        computedRightText
      }}</BaseText>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { BaseText, SkeletonLoader } from '@warrenbrasil/nebraska-web';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  leftText?: string;
  rightText?: string;
  isLoading?: boolean;
}
const props = defineProps<Props>();

const computedLeftText = computed(() => {
  return props.leftText || '-';
});

const computedRightText = computed(() => {
  return props.rightText || '-';
});
</script>

<style lang="less" scoped>
.chart-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 @size-spacing-x350;
  width: 100%;

  &__loader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    &__item {
      height: 18px;
      width: 125px;
      border-radius: @size-radius-x100;
    }
  }
}
</style>
